import React, { Component } from 'react';
import { HashLoader } from 'react-spinners';
import { Alert, Card, CardBody, CardGroup, Col, Container, Row } from 'reactstrap';
import logoAutoma from '../../../../assets/img/brand/automa-logo-black.png'
import DeliveryConfirmationDetails from './DeliveryConfirmationDetails';
import { fetchTransporterDeliveryConfirmation } from '../../../../redux/actions/aTransporter-DeliveryConfirmationDetails.jsx'
import { fetchDeliveryStatusList } from '../../../../redux/actions/aTransporter-DeliveryStatusList'
import { connect } from 'react-redux';
import DeliveryConfirmationForms from './DeliveryConfirmationForms';

class DeliveryConfirmation extends Component {
    constructor(props) {
        super(props);
        this.state = { 

         };
    }

    UNSAFE_componentWillMount = () => {
        this.props.fetchDeliveryStatusList()
        this.props.fetchTransporterDeliveryConfirmation(this.props.match.params.id)
        console.log(this.props.match.params.id)
    }

    updateYear = () => {
        var d = new Date();
        var n = d.getFullYear();
        return n;
    }

    toTitleCase = (text) => {
        text = text.toLowerCase()
                        .split(' ')
                        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                        .join(' ')

        return text
    }

    showDetails = () => {
        const { inProgress, success, transporterDeliveryConfirmationDetailsData, deliveryOrderData} = this.props;
        const { id } = this.props.match.params;
        return (
            <div>
                {
                    id ? 
                        inProgress ? 
                        <center><HashLoader color={'#123abc'} loading={inProgress}/> <br /> Memuat... Mohon menunggu...</center>
                        : 
                        (
                            success ? 
                            <DeliveryConfirmationDetails 
                                id_do={transporterDeliveryConfirmationDetailsData.delivery_id}
                                id_wo={transporterDeliveryConfirmationDetailsData.id}
                                wo_desc={transporterDeliveryConfirmationDetailsData.wo_desc}
                                transporter_company={transporterDeliveryConfirmationDetailsData.company}
                                main_customer={transporterDeliveryConfirmationDetailsData.main_customer}
                                main_customer_phone={transporterDeliveryConfirmationDetailsData.main_customer_phone}
                                wo_number={transporterDeliveryConfirmationDetailsData.wo_number}
                                loc_name={transporterDeliveryConfirmationDetailsData.loc_name}
                                eta={transporterDeliveryConfirmationDetailsData.est_arrival_time}
                                rta={transporterDeliveryConfirmationDetailsData.arrival_time}
                                id_request={transporterDeliveryConfirmationDetailsData.id_request}
                                origin_company={transporterDeliveryConfirmationDetailsData.company_requestor}
                                driver_name={deliveryOrderData.driver_name ? this.toTitleCase(deliveryOrderData.driver_name) : null}
                                driver_photo={deliveryOrderData.driver_photo_link}
                                driver_asst_name={deliveryOrderData.driver_assistant_name ? this.toTitleCase(deliveryOrderData.driver_assistant_name) : null}
                                driver_asst_photo={deliveryOrderData.driver_assist_photo_link}
                            />
                            : 
                            // <center>Error fetching your data... <br/><br/> 
                            //     <Button className="btn btn-primary" color="primary" size="md" disabled={this.props.inProgress} onClick={() => this.props.fetchTransporterDeliveryConfirmation(this.props.match.params.id)}>
                            //         <i className="fa fa-refresh"></i> 
                            //         Try again
                            //     </Button>
                            // </center>
                            <Alert color="success">
                                Link konfirmasi untuk pengiriman anda sudah ditutup atau anda telah melakukan konfirmasi sebelumnya. Harap hubungi supplier anda untuk melakukan verifiaksi lebih lanjut. <br/> Terima kasih telah menggunakan Automa.id sebagai penyedia layanan Solusi Rantai Pasok dan Manajemen Logitik
                                {/* Your package delivery confirmation link already obsolete or you already confirmed your delivery. Please contact your supplier/logistic to verify delivery status. Thank you for trusting Automa ID as your one and only Supply Chain and Logistics Management Solution. */}
                            </Alert>
                        )
                    :
                    <Alert color="success">
                        Link konfirmasi untuk pengiriman anda sudah ditutup atau anda telah melakukan konfirmasi sebelumnya. Harap hubungi supplier anda untuk melakukan verifiaksi lebih lanjut. <br/> Terima kasih telah menggunakan Automa.id sebagai penyedia layanan Solusi Rantai Pasok dan Manajemen Logitik
                        {/* Your package delivery confirmation link already obsolete or you already confirmed your delivery. Please contact your supplier/logistic to verify delivery status. Thank you for trusting Automa ID as your one and only Supply Chain and Logistics Management Solution. */}
                    </Alert>
                }
            </div>
        )
    }

    showForms = () => {
        
        const { inProgress, success, transporterDeliveryConfirmationDetailsData, customerApprovalStatus, deliveryStatusApproveOnlyData } = this.props;
        const { id } = this.props.match.params;
        return (
            <div>
                {
                    id ? 
                        inProgress ? 
                        <center><HashLoader color={'#123abc'} loading={inProgress}/> <br /> Loading.... Please wait...</center>
                        : 
                        (
                            success ? 
                            (
                                customerApprovalStatus ? 
                                <Alert color="success">
                                    Link konfirmasi untuk pengiriman anda sudah ditutup atau anda telah melakukan konfirmasi sebelumnya. Harap hubungi supplier anda untuk melakukan verifiaksi lebih lanjut. <br/> Terima kasih telah menggunakan Automa.id sebagai penyedia layanan Solusi Rantai Pasok dan Manajemen Logitik
                                    {/* Your package has been confirmed for the delivery. You cannot change the status after you submit the details. Thank you for trusting Automa ID as your one and only Supply Chain and Logistics Management Solution. */}
                                </Alert>
                                :
                                <DeliveryConfirmationForms 
                                    id_do={transporterDeliveryConfirmationDetailsData.delivery_id}
                                    id_wo={transporterDeliveryConfirmationDetailsData.id}
                                    share_data={this.props.match.params.id}
                                    fetchDelivery={this.props.fetchTransporterDeliveryConfirmation}
                                    deliveryStatusListData={deliveryStatusApproveOnlyData}
                                    customerApprovalStatus={customerApprovalStatus}
                                />
                            )
                            
                            : 
                            // <center>Error fetching your data... <br/><br/> 
                            //     <Button className="btn btn-primary" color="primary" size="md" disabled={this.props.inProgress} onClick={() => this.props.fetchTransporterDeliveryConfirmation(this.props.match.params.id)}>
                            //         <i className="fa fa-refresh"></i> 
                            //         Try again
                            //     </Button>
                            // </center>
                            true
                        )
                    :
                    <Alert color="primary">
                        Mohon menunggu... Kami sedang melakukan pengecekan terhadap data anda...
                    </Alert>
                }
            </div>
        )
    }

    render() {
        return (
            <div className="app flex-row align-items-center login-body">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="9" xs="12">
                            <CardGroup>
                                <Card className="p-4">
                                    <CardBody>
                                        <img src={logoAutoma} alt="Automa Logo" className="automa-logo-login" style={{'maxWidth': '2em', 'height': 'auto'}}/>
                                        <br/><br/>
                                        <h4>Automa - Konfirmasi Penerimaan Barang</h4><br/>
                                        
                                        {this.showDetails()}
                                        <br/><br/>
                                        {this.showForms()}
                                    </CardBody>
                                    <Row>
                                        <Col md="12">
                                            <span className="pull-right"><a href="https://automa.id">Automa</a> &copy; {this.updateYear()}</span>
                                        </Col>
                                    </Row>
                                </Card>
                            </CardGroup>
                        </Col>
                    </Row>
                    
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        transporterDeliveryConfirmationDetailsData: state.transporterDeliveryConfirmationDetailsStore.transporterDeliveryConfirmationDetailsData,
        customerApprovalStatus: state.transporterDeliveryConfirmationDetailsStore.customerApprovalStatus,
        success: state.transporterDeliveryConfirmationDetailsStore.success,
        inProgress: state.transporterDeliveryConfirmationDetailsStore.inProgress,
        deliveryOrderData : state.transporterDeliveryConfirmationDetailsStore.deliveryOrderData,

        deliveryStatusListData: state.deliveryStatusListStore.deliveryStatusListData,
        deliveryStatusApproveOnlyData: state.deliveryStatusListStore.deliveryStatusApproveOnlyData,
        inProgressDelivery: state.deliveryStatusListStore.inProgress,
        successDeliveryStatus: state.deliveryStatusListStore.success,
      }
}

export default connect(mapStateToProps, {fetchTransporterDeliveryConfirmation, fetchDeliveryStatusList})(DeliveryConfirmation);


// WEBPACK FOOTER //
// ./src/views/Transporter/DeliveryConfirmation/ID-id/DeliveryConfirmation.jsx